<template>
  <filter-summary
    icon="option"
    title="オプション"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>相手：{{ compareLabel }}</div>
    <div>ソート順：{{ sortLabel }}</div>
    <div>{{ expectLabel }}</div>
  </filter-summary>
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「オプション」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    compare: {
      type: String,
      default: 'item',
    },
    sort: {
      type: String,
      default: 'desc',
    },
    expect: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    compareLabel() {
      if (this.compare) {
        switch (this.compare) {
          case 'item':
            return '単品'
          case 'category':
            return 'カテゴリ'
          default:
            return ''
        }
      }
      return ''
    },
    sortLabel() {
      if (this.sort) {
        switch (this.sort) {
          case 'compare':
            return '逆引き(相手本位)'
          case 'base':
            return '順引き(自分本位)'
          default:
            return ''
        }
      }
      return ''
    },
    expectLabel() {
      return this.expect ? '合計政策ボリュームが期待できる' : ''
    },
  },
}
</script>
